import { createSelector } from 'reselect'


const getAuthorizationFee = createSelector(
  ({ isPayPal }) => isPayPal,
  ({ useCredits }) => useCredits,
  ({ isCreditCard }) => isCreditCard,
  ({ payPalAuthorizationFee }) => payPalAuthorizationFee,
  ({ creditCardAuthorizationFee }) => creditCardAuthorizationFee,
  ({ isEnoughVindiciaCreditsToBuy }) => isEnoughVindiciaCreditsToBuy,
  (isPayPal, useCredits, isCreditCard, payPalAuthorizationFee,
    creditCardAuthorizationFee, isEnoughVindiciaCreditsToBuy) => {
    const canUseVindiciaCredits = Boolean(
      isPayPal
      && useCredits
      && isEnoughVindiciaCreditsToBuy
    )

    let authorizationFee = canUseVindiciaCredits ? payPalAuthorizationFee : null

    if (isCreditCard) {
      authorizationFee = creditCardAuthorizationFee
    }

    return {
      canUseVindiciaCredits,
      authorizationFee,
    }
  }
)


export default getAuthorizationFee
